import { AxiosError } from "axios";
import { t } from "i18next";

import { TApiError, TExtendedApiError, TSymfonyValidationError } from "@/types";

export const getApiErrormessage = (
	error: AxiosError<TExtendedApiError> | Error | null,
	subKey?: string
): string => {
	if (!error) return "";
	const data = (error as AxiosError<TExtendedApiError>)?.response?.data;
	let key = subKey
		? (data as TSymfonyValidationError)?.errors?.[subKey]
		: (data as TApiError)?.code;
	if (!key && subKey) key = (data as TApiError)?.code;
	if (key) {
		return t(`errors.api.${key}`, {
			defaultValue: (data as TApiError)?.message,
		});
	}
	return t("errors.generic");
};
